import type { SignTypedDataParameters } from '@wagmi/core';
import { type Config, signTypedData } from '@wagmi/core';
import type { TypedData } from 'viem';
import type { EIP712SchemaType } from '@/service/EVM/EIP712Schemas/types';

export default class EvmSignature<
    TData extends Record<string, unknown>,
    TFormatted extends Record<string, unknown>,
    TTypes extends TypedData | Record<string, unknown>
> {
    formatted: TFormatted;
    signTypedData: typeof signTypedData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    types: Record<string, any>;

    constructor(data: TData, config: EIP712SchemaType<TData, TFormatted, TTypes>) {
        this.types = config.types;
        this.formatted = config.processor(data);
        this.signTypedData = signTypedData;
    }

    async create(
        config: Config,
        parameters: Omit<SignTypedDataParameters, 'message' | 'types'>
    ) {
        // const res = await this.emitter.emit(
        //     'createSignature',
        //     async () => {
        //         return await this.signTypedData(config, {
        //             ...parameters,
        //             message: this.formatted,
        //             types: this.types
        //         });
        //     },
        //     null // `payload` из EvmEventMap
        // );
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        function customStringify(value: any): string {
            return JSON.stringify(value, (_, v) =>
                typeof v === 'bigint' ? v.toString() : v
            );
        }

        const serializedData = customStringify({
            ...parameters,
            message: this.formatted,
            types: this.types
        });

        const res = await this.signTypedData(config, {
            ...parameters,
            message: this.formatted,
            types: this.types
        });

        return res;
    }
}
